import { defineStore } from 'pinia';
import { v4 as uuidv4 } from 'uuid';
import { useNetwork } from '@vueuse/core';
import { UAParser } from 'ua-parser-js';

const useDeviceStore = defineStore('KePuDevice', {
  state: () => ({
    deviceId: '',
    deviceInfo: UAParser(window.navigator.userAgent),
  }),
  getters: {
    network() {
      const { effectiveType, type } = useNetwork();
      if (type.value === 'wifi') {
        return type.value;
      }
      const result = ['3g', '4g', '5g', '6g'].includes(
        effectiveType.value?.toLowerCase() ?? ''
      )
        ? effectiveType.value || '4g'
        : '4g';
      return result;
    },
    isMobile(state) {
      return state.deviceInfo.device.is('mobile');
    },
  },
  actions: {
    generateDeviceId() {
      this.deviceId = uuidv4();
    },
  },
  persist: true,
});

export default useDeviceStore;
